import {
  INinjaEvent,
  useQueuedEventStore
} from '@ninjacart/nc-events-sdk-v2';
import { KissanEventType, useProfileStore } from '@ninjacart/nc-nk-store';
import {
  Button,
  HelpFullRegular,
  HelpFullSolid,
  NotHelpFullRegular,
  NotHelpFullSolid,
  Paragraph,
  RootContainer,
  ScrollView,
  Stack,
  Text,
  XStack,
  YStack
} from '@ninjacart/nc-nk-ui';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
export function QnaSubmitFeedback(bottom) {
  const { t } = useTranslation();
  const [helpFull, setHelpFull] = useState(false);
  const [notHelpFull, setNotHelpFull] = useState(false);
  const userProfile = useProfileStore((state) => state.userProfile);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const handleHelpFullClick = () => {
    setHelpFull(!helpFull);
    const helpFulSuccessEvent : INinjaEvent = {
      name: KissanEventType.QNA_HELPFULCLICK_SUCCESS,
      screenDetails: { screen: 'qna page' }
    };
    enqueue(helpFulSuccessEvent);
  };
  const handleNotHelpFullClick = () => {
    setNotHelpFull(!notHelpFull);
    const notHelpFulSuccessEvent : INinjaEvent= {
      name: KissanEventType.QNA_NOTHELPFULCLICKS_SUCCESS,
      screenDetails: { screen: 'qna page' }
    };
    enqueue(notHelpFulSuccessEvent);
  };
  return (
    <RootContainer paddingTop={10} flex={1} position="relative">
      <YStack borderBottomWidth={1} borderBottomColor={'$grey'}>
        <XStack paddingHorizontal={10}>
          <Paragraph fontSize={20} fontWeight={'600'} paddingBottom={2} marginBottom={15}>
            {t('page.submitFeedback')}
          </Paragraph>
        </XStack>
      </YStack>

      <ScrollView horizontal={false} showsVerticalScrollIndicator={false}>
        <YStack marginVertical={10}>
          <Paragraph fontSize={17} fontWeight={'600'} paddingBottom={2} marginBottom={15}>
            {t('page.areYouSatisfiedWithTheAnswer')}
          </Paragraph>

          <XStack display={'flex'} gap={60} justifyContent={'center'} marginTop={5}>
            <Stack
              padding={5}
              position="relative"
              bottom={2}
              alignItems="center"
              marginRight={10}
              onPress={handleHelpFullClick}
              testID='kisan_tId_helpful_click'
            >
              {helpFull ? (
                <HelpFullSolid size={50} color={'$primary'} />
              ) : (
                <HelpFullRegular size={50} color={'$color'} />
              )}

              <Paragraph
                marginRight={10}
                marginTop={5}
                fontSize={14}
                color={helpFull ? '$primary' : '$color'}
                fontWeight={'600'}
              >
                {t('page.helpful')}
              </Paragraph>
            </Stack>

            <Stack
              padding={5}
              position="relative"
              bottom={2}
              alignItems="center"
              marginRight={10}
              onPress={handleNotHelpFullClick}
              testID='kisan_tId_notHelpful_click'
            >
              {notHelpFull ? (
                <NotHelpFullSolid size={50} color={'#D11A2A'} />
              ) : (
                <NotHelpFullRegular size={50} color={'$color'} />
              )}

              <Paragraph
                marginRight={10}
                marginTop={5}
                fontSize={14}
                color={notHelpFull ? '#D11A2A' : '$color'}
                fontWeight={'500'}
              >
                {t('page.notHelpful')}
              </Paragraph>
            </Stack>
          </XStack>
        </YStack>

        {notHelpFull && (
          <YStack>
            <Paragraph fontSize={17} fontWeight={'600'} paddingBottom={2} marginBottom={15}>
              {t('page.whatWentWrong')}
            </Paragraph>
            <YStack>
              <XStack flexWrap="wrap" gap={10}>
                <Text
                  borderWidth={1}
                  fontSize={16}
                  fontWeight={'500'}
                  borderColor={'$grey'}
                  padding={10}
                  borderRadius={50}
                >
                  Want a better answer
                </Text>
                <Text
                  borderWidth={1}
                  fontSize={16}
                  color={'$primary'}
                  backgroundColor={'#E8FBF2'}
                  fontWeight={'500'}
                  borderColor={'$primary'}
                  padding={10}
                  borderRadius={50}
                >
                  Want a better answer
                </Text>
                <Text
                  borderWidth={1}
                  fontSize={16}
                  fontWeight={'500'}
                  borderColor={'$grey'}
                  padding={10}
                  borderRadius={50}
                >
                  Want a better answer
                </Text>
              </XStack>
            </YStack>
          </YStack>
        )}
      </ScrollView>

      <XStack position="absolute" bottom={5}>
        <Button
          backgroundColor={'#368665'}
          borderRadius="$2"
          letterSpacing={'$10'}
          color={'#fff'}
          width={'100%'}
          fontWeight={'600'}
          size="$6"
        >
          {t('page.submit')}
        </Button>
      </XStack>
    </RootContainer>
  );
}
